const Component = () => import('./Form');

export { Component };
